import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  title: {
    textTransform: 'uppercase',
    color: theme.palette.action.main,
  },
  subtitle: {
    fontSize: 13,
  },
  tableHeader: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
  },
  tableRow: {
    '&:nth-child(even)': {
      backgroundColor: '#e3e3e3',
    },
  },
  paper: {
    maxHeight: 200,
  },
}));
